/**
* 分页组件
*/ 
<template>
  <el-pagination class="page-box" @size-change="handleSizeChange" @current-change="handleCurrentChange" background
    :current-page="childMsg.currentPage" :page-size="childMsg.pageSize" :page-sizes="[10, 15, 20]"
    layout="total, sizes, prev, pager, next, jumper" :total="childMsg.total ? childMsg.total : 0">
  </el-pagination>
</template>
<script>

import en from 'element-ui/lib/locale/lang/en'

export default {
  name: "Pagination",
  props: ["childMsg"],
  data() {
    return {
      pageparm: {
        currentPage: this.childMsg.currentPage,
        pageSize: this.childMsg.pageSize,
      },
    };
  },
  watch: {
    'childMsg.total': function (newTotal) {
      en.el.pagination.total = 'Total ' + newTotal + (newTotal > 1 ? ' Records' : ' Record');
    }
  },
  created() {
    this.pageparm.currentPage = 1;
    console.log("初始当前页", this.childMsg);
  },
  mounted() {

    // en.el.pagination.total = 'Total ' + this.childMsg.total + (this.childMsg.total > 1 ? ' Records' : 'Record');

    // document.getElementsByClassName('el-pagination__total')[0].childNodes[0].nodeValue = 'Total ' + this.childMsg.total +  (this.childMsg.total > 1 ? ' Records' : 'Record');
    document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue = 'Go to page';
  },
  methods: {
    handleSizeChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.pageparm.pageSize = val;
      this.pageparm.currentPage = this.childMsg.currentPage;
      this.$emit("callFather", this.pageparm);
      console.log("页码大小变化", val);
    },
    handleCurrentChange(val) {
      /**
       * 子传父
       * 参数1 父元素方法
       * 参数2 数据
       */
      this.pageparm.currentPage = val;
      this.$emit("callFather", this.pageparm);
      console.log("当前页", val);
    },
  },
};
</script>

<style>
.page-box {
  margin: 10px auto;
}
.page-box .el-pager li {
  font-size: 10px;
  font-weight: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue